<template>
  <div id="welcome-banner" style="position: static">
    <v-container id="content" class="pa-0 pt-2">
      <v-layout row>
        <v-flex xs5 sm5 md4 class="pt-1 pl-3 pr-2">
          <v-img src="/svg_icon.png" />
        </v-flex>
        <v-flex xs7 sm7 md8 class="pt-4 pl-2">
          <div>
            <h4 id="welcome-message">あなたのきもちをカタチにしよう</h4>
            <v-btn
              id="make-graph"
              color="secondary"
              class="mx-0 mt-4"
              :to="{name: 'create'}"
              dark
              round
            >今すぐグラフをつくる！
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      :width="width"
      :height="height"
    >
      <path class="background" :d="svgPath"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "WelcomeBanner",
  data() {
    return {
      width: 0,
      height: 0,
      linkItem: {
        graph: {
          to: "/create-graph",
          title: "graph",
        }
      }
    };
  },
  mounted() {
    this.width = window.outerWidth;
    this.height = this.$el.clientHeight;

    /* ウィンドウのリサイズに対応する場合はThrottleを実装して実行回数をキャップしないと描画負荷が上がるので注意 */
    /* @REF https://dev.classmethod.jp/client-side/handling-resized-event/ */
    // window.addEventListener('resize', this.updateWidth_PC);
    window.addEventListener("orientationchange", this.updateWidth_Tablet);
  },
  destroy() {
    // window.removeEventListener('resize', this.updateWidth_PC);
    window.removeEventListener("orientationchange", this.updateWidth_Tablet);
  },
  methods: {
    updateWidth_PC() {
      this.width = window.outerWidth;
    },
    updateWidth_Tablet() {
      this.width = window.screen.width;
    }
  },
  computed: {
    svgPath() {
      const { width, height } = this;
      const a = 0.2;

      return `M0 0
     V ${height * (1 - a)}
     q ${width * 0.25} ${height * a} ${width * 0.5} ${0}
     q ${width * 0.25} ${-1 * height * a} ${width * 0.5} ${0}
     V ${-1 * height * (1 - a)}
     Z
     `;
    }
  }
};
</script>

<style scoped lang="scss">
#welcome-banner {
  height: 400px;

  @media screen and (max-width: 896px) {
  }
  @media screen and (max-width: 480px) {
    height: 200px;
  }

  #content {
    position: relative;
    z-index: 1;

    #welcome-message {
      font-size: 1.1rem;
      @media screen and (max-width: 896px) {
      }
      @media screen and (max-width: 480px) {
        font-size: 0.8rem;
      }
    }

    #make-graph {
      @media screen and (max-width: 896px) {
      }
      @media screen and (max-width: 480px) {
        font-size: 0.8rem;
      }
    }
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;

    path.background {
      fill: #FFDE59;
    }
  }
}
</style>
